import axiosApiInstance from '../../interceptors/axiosApiInstance';
import { BASE_URL } from '../config';

const VariantService = {
  getVariant: async function (categories, sources, dest) {
    try {
      const response = await axiosApiInstance.get(BASE_URL + `/variant?category_id=${categories}&source_app_id=${sources}&destination_app_id=${dest}`);
      return response.data;
    } catch (error) {
      return error.response ? error.response.data : undefined;
    }
  },
  getVariantConfig: async function (id, etarget) {
    try {
      const response = await axiosApiInstance.get(BASE_URL + `/variant/config?bot_id=${id}&environment_target=${etarget}`);
      return response.data;
    } catch (error) {
      return error.response ? error.response.data : undefined;
    }
  },
  variantTestRun: async function(data){
    try {
      const response = await axiosApiInstance.post(BASE_URL + `/variant/test/run`, data);
      return response.data;
    } catch (error) {
      return error.response ? error.response.data : undefined;
    }
  },
  variantDeploy: async function(data){
    try {
      const response = await axiosApiInstance.post(BASE_URL + `/variant/deploy`, data);
      return response.data;
    } catch (error) {
      return error.response ? error.response.data : undefined;
    }
  },
  getLog: async function (id) {
    try {
      const response = await axiosApiInstance.get(BASE_URL + `/log?open_id=${id}`);
      return response.data;
    } catch (error) {
      return error.response ? error.response.data : undefined;
    }
  }
};
export default VariantService;